import { z } from 'zod';

export const zodAddressSchema = z.object({
  buildingNumber: z.union([z.string().trim(), z.literal('')]).nullish(),
  city: z.union([z.string().trim(), z.literal('')]).nullish(),
  country: z.union([z.string().trim().length(2), z.literal('')]).nullish(),
  postCode: z.union([z.string().trim(), z.literal('')]).nullish(),
  streetName: z.union([z.string().trim(), z.literal('')]).nullish(),
});
